































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import getUrlParam from '@/common/utils/getUrlParam';

@Component
export default class ScanTitle extends Vue {
  @Getter("scanBackground") scanBackground!: string;
  @Getter("scanTextColor") scanTextColor!: string;
  @Getter("scanSubTextColor") scanSubTextColor!: string;
  @Getter("scanNumber") scanNumber!: number;
  @Getter("joinNumber") joinNumber!: number;

  type: string = getUrlParam("type") as string;
}
